/* eslint-disable no-invalid-this */
export function initFormElements() {
    // init radio, check, and smnile inputs
    let checkRadioTypes = $(document).find('.form-group.is-option');

    checkRadioTypes.each(function() {
        let inp = $(this).find('input');

        inp.on('change', function() {
            let parent = inp.closest('.is-option');
            let parentGroup = inp.closest('.options-group');

            parentGroup.find('.is-option').removeClass('is-checked');

            if (inp.is(':checked')) {
                parent.addClass('is-checked');

                // check if it's an (other option)
                if (parent.hasClass('has-reason')) {
                    parentGroup.find('.other-reason').addClass('is-active');
                    parentGroup.find('.other-reason input').trigger('focus');
                } else {
                    parentGroup.find('.other-reason').removeClass('is-active');
                }
            } else {
                parent.removeClass('is-checked');
            }
        });
    });

    // init file type inputs
    let fileInputs = $(document).find('[data-file-field="true"]');

    fileInputs.each(function() {
        let inp = $(this).find('input[type="file"]');
		let fileStatus = $(this).find('.fileStatus');

		if (fileStatus.length == 0) {
			fileStatus = $(this).closest('.file-row').find('.fileStatus');
		}

        inp.on('change', function() {
			fileStatus.text('');

			if (this.files) {
				for (let i = 0; i < this.files.length; i++) {
					fileStatus.append(`<div>${this.files[i].name}</div>`);
				}
			}
        });
    });
}
